<div class="full-screen-busy-wrap">
  <div [ngBusy]="{busy: cakeSaving, message: ('common.pleaseWait' | translate)}"></div>
</div>

@if (cake && showCakeInfo) {
  <cake-info
    [cake]="cake"
    [isSinglePiecesCake]="isSinglePiecesCake"
    [currency]="bakeryCurrency.symbol"
    [disabledBackButton]="disabledBackButton"
    [standAloneMode]="standAloneMode"
    [orderDeadlines]="orderDeadlines"
    [specialDeadlines]="specialDeadlines"
    [showBakeryDeadline]="showBakeryDeadline"
    [showCustomNote]="showCustomNote"
    [noteContext]="noteContext"
    [bakeryUrl]="bakeryUrl"
    [isConcreteProductType]="isConcreteProductType"
    [showBakeryInfo]="showBakeryInfo"
    (onBakeryNameClicked)="onBakeryNameClicked.emit($event)"
    (onBackButtonClicked)="onBack.emit()"
    (onShowPickup)="checkDelivery(DELIVERY_TYPES.PICKUP)"
    (onShowDelivery)="checkDelivery(DELIVERY_TYPES.DELIVERY)"
  ></cake-info>
}

@if (cartLine && cake && loaded) {
  <ng-content select=".content-area-after-cake-info"></ng-content>

  @if (isConcreteProductType) {
    <!-- the order area: ws-product-detail__builder on the product page, ws-product-detail__builder-modal in the
         product modal (standAloneMode off); builder-paddings: there is something to choose (the default padding);
         ws-product-detail__options: the white background around the option groups -->
    <div [class.ws-product-detail__options]="isConcreteProductTypeNotEmpty"
         [class.builder-paddings]="!(isSinglePiecesNoAddons || isComplexOneSizeNoAddonsNoVariants)"
         [class.ws-product-detail__builder]="standAloneMode"
         [class.ws-product-detail__builder-modal]="!standAloneMode">
      @if (standAloneMode && !isSinglePiecesNoAddons && !isComplexOneSizeNoAddonsNoVariants) {
        @if (showTitleForComplex || isSinglePiecesWithAddons) {
          <div class="start-order-title ws-product-detail__start-title d-none d-sm-block"
               [translate]="'cakeBuilder.title'"></div>
        }
        @if (isPiecesGroupType) {
          <div class="start-order-title ws-product-detail__start-title"
               [translate]="'cakeBuilder.cakeVariantsSection.piecesGroupTitle'"></div>
        }
        @if (isPiecesWithMultipleVariants && cake.structureType===STRUCTURE_TYPES.PIECES) {
          <div class="start-order-title ws-product-detail__start-title"
               [translate]="'cakeBuilder.cakeVariantsSection.piecesTitle'"></div>
        }
      }


      @if (!cake.pieces && cake.sizes.length > 1) {
        <cake-sizes-section
          class="border-for-build-section"
          [sizes]="sizes"
          [details]="details"
          [active]="!cartLine.size"
          [activeSize]="cartLine.size"
          [currency]="bakeryCurrency.symbol"
          [discount]="cake.discount?.value"
          (onSelect)="onSizeUpdated($event)"
        ></cake-sizes-section>
      }

      @if ((variants && variants.length > 1 && !isPiecesWithMultipleVariants) || isPiecesGroupType) {
        <div class="border-for-build-section-wrapper" #cakeVariantsSection>
          @if (variants && variants.length > 1 && !isPiecesWithMultipleVariants) {
            <cake-variants-section
              class="border-for-build-section"
              [disabled]="!cartLine.size"
              [active]="cartLine.size && !cartLine.variant"
              [variants]="variants"
              [details]="details"
              [isPieces]="cartLine.size?.details.pieces"
              [activeVariant]="cartLine.variant"
              [currency]="bakeryCurrency.symbol"
              [discount]="cake.discount?.value"
              (onSelect)="onFillingUpdated($event)"
            ></cake-variants-section>
          }

          @if (isPiecesGroupType) {
            <cake-multiple-variants-section
              class="border-for-build-section"
              [variants]="variants"
              [countPerVariantMap]="countPerVariantMap"
              [currency]="bakeryCurrency.symbol"
              [step]="cartLine.productType.increment"
              [minCountPerProduct]="cake.minQuantityPerProduct"
              [maxQuantity]="effectiveMaxQuantity"
              [discount]="cake.discount?.value"
              (onSelect)="onMultipleFillingUpdated($event)"
            ></cake-multiple-variants-section>
          }
        </div>
      }

      <div class="border-for-build-section-wrapper" #optionalSections>
        <common-addons-section
          [sortingAddons]="sortingAddons"
          [cartLine]="cartLine"
          [currency]="bakeryCurrency.symbol"
          [disabled]="isBuilderSectionsDisabled"
          [disabledChooseMotiveModal]="disabledChooseMotiveModal"
          [isPiecesWithMultipleVariants]="isPiecesWithMultipleVariants"
          [isRequirementsExist]="isRequirementsExist"
          [isRequirementsFilled]="isRequirementsFilled"
          [requirementsFilling]="requirementsFilling"
          [printingPictureMap]="printingPictureMap"
          [deposits]="deposits"
          (onPrintingPictureSelected)="onPrintingPictureSelected($event.addOn, $event.printingPicture)"
          (onExtraProductSelected)="onExtraProductSelected($event.products, $event.groupId)"
          (onQuestionAnswerChange)="onQuestionAnswerChange($event.answer, $event.question)"
        ></common-addons-section>

        @if (cake.greetingCard.available && cartLine.greetingCard && !isPiecesGroupType) {
          <greeting-card-section
            class="border-for-build-section"
            [disabled]="!cartLine.variant || isRequirementsExist && !isRequirementsFilled"
            [cardPrice]="cake.greetingCard.price"
            [text]="cartLine.greetingCard?.text"
            [maxLength]="cake.greetingCard.maxLength"
            [currency]="bakeryCurrency.symbol"
            (onChecked)="cartLine.greetingCard.checked=$event; greetingCardPriceCalculation()"
            (onTextChange)="cartLine.greetingCard.text=$event; greetingCardPriceCalculation()"
          ></greeting-card-section>
        }
      </div>
    </div>
  }

  <!-- FOR COMPLEX and SINGLE PIECES -->
  @if (isConcreteProductType && !isPiecesGroupType) {
    <ng-container *ngTemplateOutlet="submitCakeQuantity"></ng-container>
  }

  <!-- FOR PIECES GROUP -->
  @if (isConcreteProductType && isPiecesGroupType) {
    <ng-container *ngTemplateOutlet="multipleVariantsSubmit"></ng-container>
  }

  @if (upsellProductTypes?.length) {
    @if (isConcreteProductType) {
      <div class="upsell-title ws-product-detail__upsell-title"
           [class.upsell-title--indented]="!standAloneMode">
        {{ cake.upsellProductsTitle ? cake.upsellProductsTitle : ('cakeBuilder.wantAnyExtras' | translate )}}
      </div>
    }

    @for (upsellProductType of upsellProductTypes; track upsellProductType) {
      <div class="ws-product-detail__options ws-product-detail__upsell builder-paddings"
           [class.ws-product-detail__builder]="standAloneMode"
           [class.ws-product-detail__builder-modal]="!standAloneMode">
        <upsell-products-section
          [upsellProductType]="upsellProductType"
          [upsellLinesGroup]="upsellAddonsByProductTypeId[upsellProductType.id]"
          [currency]="bakeryCurrency.symbol"
          (onSelect)="onUpsellProductUpdated($event)"
          (onAddonsUpdated)="onUpsellAddonsUpdated($event)"
        ></upsell-products-section>
      </div>
    }

    <ng-container *ngTemplateOutlet="upsellSubmitTemplate"></ng-container>
  }
}

<ng-template #upsellSubmitTemplate>
  <div class="build-section-footer ws-product-detail__footer"
       [ngClass]="{'mb-3 mb-xs-max-5': showSubmitButtonsAsSticky}"
       [class.build-section-footer__no-border]="standAloneMode"
       [class.footer-moved]="moveStickyBottomButtons"
  >
    <cake-price-total
      class="d-block mt-sm-max-2 text-center"
      [totalPrice]="totalPrice"
      [extraPrice]="totalPriceUpsell"
      [currency]="bakeryCurrency.symbol"
    ></cake-price-total>

    @if (!showSubmitButtonsAsSticky) {
      <ng-container *ngTemplateOutlet="upsellSubmitButtons"></ng-container>
    }
  </div>

  @if (showSubmitButtonsAsSticky) {
    <ng-container *ngTemplateOutlet="upsellSubmitButtons"></ng-container>
  }

  <ng-template #upsellSubmitButtons>
    <submit-buttons-section
        class="d-block p-2"
        [ngClass]="{'pt-4': showSubmitButtonsAsSticky, 'mt-3': !showSubmitButtonsAsSticky}"
        [disabled]="isUpsellsSubmitButtonsDisabled"
        [showAsSticky]="showSubmitButtonsAsSticky"
        [addMoreButtonText]="addMoreButtonText"
        [saveButtonText]="saveButtonText"
        [showOnlySaveButton]="(cartLine.id && showSingleButtonForExistingOrderLine) || showOnlySaveButton"
        [moveStickyBottomButtons]="moveStickyBottomButtons"
        (onSubmit)="submit($event)"
    ></submit-buttons-section>
  </ng-template>

</ng-template>

<!--For pieces cake with multiple variants-->
<ng-template #multipleVariantsSubmit>
  <div class="build-section-footer ws-product-detail__footer"
       [ngClass]="{'mb-3 mb-xs-max-5': showSubmitButtonsAsSticky}"
       [class.build-section-footer__no-border]="standAloneMode"
       [class.footer-moved]="moveStickyBottomButtons">

    <cake-total-stk
      [price]="totalPrice"
      [quantity]="totalQuantity"
      [currency]="bakeryCurrency.total"
    ></cake-total-stk>

    @if (cake.minQuantity > 1 || cake.maxQuantity || stockLeft !== null || dailyLimit !== null) {
      <div class="text-center mt-1">
        <product-quantity-info
          [min]="cake.minQuantity"
          [max]="cake.maxQuantity"
          [stockLeft]="stockLeft"
          [dailyLimit]="dailyLimit"
          [unitKey]="cartLine.size?.details?.unit?.key"
        ></product-quantity-info>
      </div>
    }

    @if (!showSubmitButtonsAsSticky) {
      <ng-container *ngTemplateOutlet="multipleVariantsSubmitButtons"></ng-container>
    }
  </div>

  @if (showSubmitButtonsAsSticky) {
    <ng-container *ngTemplateOutlet="multipleVariantsSubmitButtons"></ng-container>
  }

  <ng-template #multipleVariantsSubmitButtons>
    <submit-buttons-section
        class="d-block p-2"
        [ngClass]="{'pt-4': showSubmitButtonsAsSticky, 'mt-3': !showSubmitButtonsAsSticky}"
        [showAsSticky]="showSubmitButtonsAsSticky"
        [moveStickyBottomButtons]="moveStickyBottomButtons"
        [disabled]="isMultiVariantSubmitDisabled"
        [showOnlySaveButton]="(cartLine.id && showSingleButtonForExistingOrderLine) || showOnlySaveButton"
        [saveButtonText]="saveButtonText"
        (onSubmit)="submit($event)"
    ></submit-buttons-section>
  </ng-template>
</ng-template>

<ng-template #submitCakeQuantity>
  <div class="build-section-footer build-section-footer--counter ws-product-detail__footer"
       [ngClass]="{'mb-3 mb-xs-max-5': showSubmitButtonsAsSticky}"
       [class.build-section-footer__no-border]="standAloneMode"
       [class.footer-moved]="moveStickyBottomButtons">
    <cake-counter
      [cartLine]="cartLine"
      [discount]="cake.discount?.value"
      [currency]="bakeryCurrency.symbol"
      [disabled]="isBuilderSectionsDisabled"
      (onLineUpdated)="cakeCounterUpdated($event)"
    >
      @if (isSinglePiecesCake) {
        <div class="mt-2 font-xl text-center">
          {{('cakeBuilder.sizeUnits.quantityText.' + cake?.sizes[0].details?.unit?.key) | translate}}
        </div>
      }
    </cake-counter>

    @if ((cartLine.size?.details.pieces &&
          (cartLine.productType.minQuantity > 1 || cartLine.productType.maxQuantity)) ||
         stockLeft !== null ||
         dailyLimit !== null) {
      <div class="text-center mt-xs-max-1 mt-sm-min-3">
        <product-quantity-info
          [min]="cartLine.productType.minQuantity"
          [max]="cartLine.productType.maxQuantity"
          [stockLeft]="stockLeft"
          [dailyLimit]="dailyLimit"
          [unitKey]="cartLine.size?.details?.unit?.key"
        ></product-quantity-info>
      </div>
    }

    @if (!showSubmitButtonsAsSticky) {
      <ng-container *ngTemplateOutlet="cakeQuantitySubmitButtons"></ng-container>
    }
  </div>

  @if (showSubmitButtonsAsSticky) {
    <ng-container *ngTemplateOutlet="cakeQuantitySubmitButtons"></ng-container>
  }

  <ng-template #cakeQuantitySubmitButtons>
    <submit-buttons-section
        class="d-block p-2"
        [ngClass]="{'pt-4': showSubmitButtonsAsSticky, 'mt-4': !showSubmitButtonsAsSticky}"
        [showAsSticky]="showSubmitButtonsAsSticky"
        [moveStickyBottomButtons]="moveStickyBottomButtons"
        [disabled]="isBuilderSectionsDisabled"
        [addMoreButtonText]="addMoreButtonText"
        [showOnlySaveButton]="(cartLine.id && showSingleButtonForExistingOrderLine) || showOnlySaveButton"
        [saveButtonText]="saveButtonText"
        (onSubmit)="submit($event)"
    ></submit-buttons-section>
  </ng-template>
</ng-template>
